import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks captured text deletion',
  name: 'deleted_captured_text',
  params: [
    {
      description: 'The ID of the captured text',
      name: 'text_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The captured text',
      name: 'text',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
